export enum LocationAutocompleteSelectionType {
  location = 'location',
  currentPosition = 'currentPosition',
}
